import { ajustarTamanhoFonte, tamanhosModaisGlobais } from "../../../estilos/global";

export const cores = {
  azul: "var(--sear-azul, #087cf0)",
  titulo: "var(--sear-azul, #12338d)",
  texto: "var(--sear-azul, #24458b)",
  secundario: "var(--sear-texto-secundario, #687fb0)",
  borda: "var(--sear-borda, #e1ebf8)",
  fundo: "var(--sear-superficie-azul, #eaf4ff)",
  fundoInteracao: "var(--sear-superficie-azul, #dceeff)",
};

export const estiloDialogo = {
  "& .MuiDialog-paper": {
    m: { xs: 1, sm: 2 },
    width: { xs: "calc(100% - 16px)", sm: "calc(100% - 32px)" },
    maxWidth: 1320,
    height: { xs: "calc(100dvh - 16px)", sm: "min(740px, calc(100dvh - 32px))" },
    maxHeight: { xs: "calc(100dvh - 16px)", sm: "calc(100dvh - 32px)" },
    borderRadius: "10px",
    border: "1px solid var(--sear-borda, #b8d2f4)",
    borderTop: `3px solid ${cores.azul}`,
    overflow: "hidden",
    color: cores.texto,
    boxShadow: "0 16px 60px rgba(14, 48, 100, 0.25)",
  },
};

export const estiloSecao = {
  border: `1px solid ${cores.borda}`,
  borderRadius: "6px",
  overflow: "hidden",
};

export const estiloAbas = {
  flexShrink: 0,
  mx: { xs: 1.5, sm: 2 },
  mb: 1.5,
  minHeight: 44,
  border: `1px solid ${cores.borda}`,
  borderRadius: "5px",
  "& .MuiTabs-indicator": { bgcolor: cores.azul },
  "& .MuiTab-root": {
    minWidth: 0,
    minHeight: 44,
    px: { xs: 0.5, sm: 1.5 },
    py: 1,
    textTransform: "none",
    fontSize: { xs: ajustarTamanhoFonte("11px"), sm: tamanhosModaisGlobais.aba },
    fontWeight: 600,
    color: cores.texto,
    bgcolor: "var(--sear-superficie, #fff)",
    borderRight: `1px solid ${cores.borda}`,
    transition: "background-color 160ms ease, color 160ms ease",
    "@media (prefers-reduced-motion: reduce)": { transition: "none" },
    "& .MuiSvgIcon-root": { fontSize: 20, mr: { xs: 0.5, sm: 1 } },
    "& .MuiTouchRipple-root": { color: cores.azul },
    "&:hover, &.Mui-focusVisible": {
      bgcolor: cores.fundoInteracao,
      color: cores.azul,
    },
    "&.Mui-focusVisible": { boxShadow: `inset 0 0 0 2px ${cores.azul}` },
    "&.Mui-selected": {
      bgcolor: cores.fundo,
      color: cores.azul,
      "&:hover, &.Mui-focusVisible": { bgcolor: cores.fundoInteracao },
    },
    "&:last-of-type": { borderRight: 0 },
  },
};

export const estiloTituloSecao = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  color: cores.titulo,
  fontSize: tamanhosModaisGlobais.tituloSecao,
  fontWeight: 700,
  lineHeight: 1.4,
  "& .MuiSvgIcon-root": { fontSize: 22, color: cores.azul },
};

export const estiloCampo = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "5px",
    fontSize: tamanhosModaisGlobais.campo,
    color: cores.texto,
    bgcolor: "var(--sear-superficie, #fcfdff)",
    "& fieldset": { borderColor: "var(--sear-borda, #d4e1f4)" },
    "&:hover fieldset": { borderColor: "var(--sear-borda, #90b9ef)" },
    "&.Mui-focused fieldset": { borderColor: cores.azul },
    "&.Mui-disabled": {
      color: cores.secundario,
      bgcolor: "var(--sear-superficie, #fcfdff)",
      "& fieldset": { borderColor: "var(--sear-borda, #d4e1f4)" },
    },
  },
  "& input": { py: 1, px: 1.5 },
  "& input::placeholder": { color: cores.secundario, opacity: 1 },
  "& .MuiSelect-select": { py: 1, px: 1.5 },
  "& .MuiNativeSelect-select": {
    py: 1,
    px: 1.5,
    "&:focus": { bgcolor: "transparent" },
  },
  "& .MuiInputBase-input.Mui-disabled": {
    color: cores.secundario,
    WebkitTextFillColor: cores.secundario,
    opacity: 1,
  },
  "& .MuiSelect-icon, & .MuiNativeSelect-icon": { color: cores.secundario },
  "& .MuiSelect-icon.Mui-disabled, & .MuiNativeSelect-icon.Mui-disabled": { color: cores.secundario },
};

export const estiloRotulo = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 0.5,
  mb: 0.5,
  color: cores.texto,
  fontSize: tamanhosModaisGlobais.rotulo,
  lineHeight: 1.5,
};

export const estiloBotao = {
  textTransform: "none",
  boxShadow: "none",
  whiteSpace: "nowrap",
  borderRadius: "5px",
  minHeight: 38,
  px: 2,
  fontSize: tamanhosModaisGlobais.botao,
  bgcolor: "var(--sear-acao-azul, #087cf0)",
  color: "#fff",
  "&:hover": { bgcolor: "var(--sear-acao-azul-hover, #0767d8)", boxShadow: "none" },
};

export const estiloTabela = {
  "& th, & td": {
    color: cores.texto,
    fontSize: ajustarTamanhoFonte("13px"),
    borderBottom: `1px solid ${cores.borda}`,
    borderRight: `1px solid ${cores.borda}`,
    px: { xs: 1, md: 1.75 },
    py: 0.55,
    height: 35,
    overflowWrap: "anywhere",
    "&:last-child": { borderRight: 0 },
  },
  "& thead th": {
    bgcolor: "var(--sear-superficie-azul, #e5f2ff)",
    fontWeight: 700,
    fontSize: ajustarTamanhoFonte("12px"),
  },
  "& tbody tr:last-child td, & tbody tr:last-child th": { borderBottom: 0 },
  "& tbody tr:hover": { bgcolor: "var(--sear-superficie-azul, #f6faff)" },
};

export const estiloAcao = (excluir = false) => ({
  width: 28,
  height: 28,
  color: excluir ? "var(--sear-erro-texto, #f04452)" : cores.azul,
  bgcolor: excluir ? "var(--sear-erro-fundo, #ffe9ec)" : "var(--sear-superficie-azul, #e2f1ff)",
  "&:hover": { bgcolor: excluir ? "var(--sear-erro-fundo, #ffd5dc)" : "var(--sear-superficie-azul, #cce6ff)" },
  "& .MuiSvgIcon-root": { fontSize: 17 },
});
